var _mask, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongTixing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tongyong_tixing_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 7.5a5 5 0 0110 0v6H3v-6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.5v1h1v-1h-1zm-10 0H2v1h1v-1zm9-6v6h2v-6h-2zm1 5H3v2h10v-2zm-9 1v-6H2v6h2zm4-10a4 4 0 014 4h2a6 6 0 00-6-6v2zm0-2a6 6 0 00-6 6h2a4 4 0 014-4v-2z",
    fill: "#3F465C",
    mask: "url(#tongyong_tixing_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13h12",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 14a1.5 1.5 0 003 0h-1a.5.5 0 01-1 0h-1z",
    fill: "#3F465C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.735V2",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_tixing.4dc6c0b7.svg";
export { SvgTongyongTixing as ReactComponent };